<template>
  <v-card :class="widgetCardStyle">
    <v-card-title primary-title v-if="renderTitle">
      <slot name="title">
        <div>
          <div class="headline" v-if="title">{{ title }}</div>
          <span class="grey--text" v-if="subTitle">{{ subTitle }}</span>
        </div>
      </slot>
      <v-spacer></v-spacer>
      <div class="widgetCardAction">
        <slot name="action"> </slot>
      </div>
    </v-card-title>
    <v-card-text class="widgetCardText" v-if="padded">
      <slot></slot>
    </v-card-text>
    <template v-else>
      <div class="widgetCardText">
        <slot></slot>
      </div>
    </template>
  </v-card>
</template>

<script>
export default {
  computed: {
    renderTitle() {
      return this.title || this.subTitle
    },
    widgetCardStyle() {
      let style = 'widgetCard'
      if (this.scroll) {
        style += ' widgetScroll'
      }
      return style
    }
  },
  props: {
    title: {
      type: String,
      default: undefined
    },
    subTitle: {
      type: String,
      default: undefined
    },
    padded: {
      type: Boolean,
      default: true
    },
    scroll: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.widgetCard {
  height: 100% !important;
  overflow: hidden;
  &.widgetScroll {
    overflow: auto !important;
  }
  .widgetCardText {
    width: 100%;
    // For height, if we put 100%, it will overshot the height as there might be title/subTitle above it
    // Might need come back to look at this (might need subtraction of height)
    height: 80%;
  }
  .widgetCardAction {
    min-height: 50px;
    display: inline-block;
    .btn {
      margin: 0px;
    }
  }
}
.smallWidgetLayout {
  .widgetIcon {
    font-size: 5rem !important;
  }
  .widgetIcon-small {
    font-size: 3rem !important;
  }
  .widgetHeader {
    font-size: 1.2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .widgetText {
    font-weight: 400;
    font-size: 2rem;
    white-space: nowrap;
    text-overflow: ellipsis;

    &.small {
      font-size: 1.5rem;
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
  .widgetInfoPnl {
    margin-top: 18px;
    .widgetInfo {
      padding-top: 8px;
    }
  }
}

.widgetAction {
  cursor: pointer;
}
</style>
